import URLConfig from '@Config/urls/url.config';
import { Route } from 'react-router-dom';
import * as ReportingModulePages from '@Modules/reporting/pages';

const ReportingRoutes = [
  <Route
    path={URLConfig.REPORTING.TRANSACTIONS}
    element={<ReportingModulePages.Transactions />}
  />,
  <Route
    path={URLConfig.REPORTING.CARDHOLDERS}
    element={<ReportingModulePages.Cardholders />}
  />,
  <Route
    path={URLConfig.REPORTING.PREPAID}
    element={<ReportingModulePages.Prepaid />}
  />,
  <Route
    path={URLConfig.REPORTING.DEBIT}
    element={<ReportingModulePages.Debit />}
  />,
  <Route
    path={URLConfig.REPORTING.FRAUD}
    element={<ReportingModulePages.Fraud />}
  />,
  <Route
    path={URLConfig.REPORTING.VISA_BASE_2}
    element={<ReportingModulePages.VisaBase2 />}
  />,
  <Route
    path={URLConfig.REPORTING.GIMAC}
    element={<ReportingModulePages.Gimac />}
  />
];

export default ReportingRoutes;
